<template>
  <div class="head-uppr">
    <div class="head warp">
      <div class="head-logo"><img src="../assets/logo-1.png" alt=""></div>
      <div class="head-menu">
			<ul class="navigation">
				<li v-for="(item,index) in navs"  :key="item.id" :class="{'nav-active':index == checkindex }">							
					<a v-if="item.url" :href="item.url" target="_blank">{{item.text}}</a>					
					<a v-else href="#">{{item.text}}</a>
					<!-- <router-link v-else :to="{path:item.url, query: {mainid: item.id}}">{{item.text}}</router-link> -->
					<ul v-if="item.children" class="nav-menus tec-list">
						<li v-for="subitem in item.children" :key="subitem.id">
							<router-link :to="{path:subitem.url, query: {mainid: item.id, subid: subitem.id}}">{{subitem.text}}</router-link>
						</li>
					</ul>
				</li>
			</ul>			
      </div>
	  <div class="head-menu-mobile">
		  <i class="iconfont icon-caidan" v-if='display == false' @click="dianji()"></i>
		  <i class="iconfont icon-X" v-if='display == true' @click="dianji()"></i>		   		
      </div>	 	 
    </div>
	<div class="mobile-menu" :class="{'mobiedisplay':display}">
		<ul class="m-ul" :class="{'youClass': isShow}">
			<li v-for="(item,index) in navs"  :key="index" @click="openChildren(item,item.id)">							
				<a v-if="item.url" class="alone-a" :href="item.url">{{item.text}}</a>					
				<a v-else href="#">{{item.text}}</a>	
				<span class="nav-jian" v-if="item.children && item.id == navId">-</span>			
				<ul v-if="item.id == navId" class="nav-menus tec-list" :class="{'nav-children':childrenShows}">
					<li v-for="subitem in navChildren" :key="subitem.id" @click="closeCurtain()">
							<router-link :to="{path:subitem.url, query: {mainid: item.id, subid: subitem.id}}">{{subitem.text}}</router-link>				
					</li>					
				</ul>
				<span v-if="item.children && item.id !== navId">+</span>															
			</li>
		</ul>
	</div>	
  </div>
</template>
<script>
export default {
	name: 'ihead',
	props: {
		checkindex: {
			type: Number,
			default: 0
		},
		navList:{
			type: Array,
			default: function () {
				return []
			}
		}
	},
	data () {
		return {
			navs: [],
			display:false,
			isShow:true,
			childrenShows:true,
			navChildren:[],
			navId:0		
		}
	},
	created: function () {                                                                                   
		this.getNav()	
	},		
	methods:{
		// 点击顶部导航
		dianji(){				
			this.display = !this.display
			this.isShow = !this.display			
		},
		// 点击+
		openChildren(item,index){			
			this.childrenShows = !this.childrenShows
			if(this.childrenShows == true){
				this.navId = 0							
			}else{
				this.navId = item.id
				this.navChildren = item.children
			}
		},
		// 点击遮挡收起
		closeCurtain(){
			this.display = false
			this.isShow = true
		},
		getNav () {
			this.$get('/nav/get-nav-tree').then(res => {
				if (res.code === 0) {
					let data = res.data
					// console.log(data)
					if (data){						
						this.navs = data												
					}
				} else {
					// console.log(res.message)
				}
			})
		},
		toggle (index) {			
			this.checkindex = index
		},
		toggleli(index){
			// console.log(index)
			this.checkindex = index
		}
	}
}
</script>

<style>
.navigation li .nav-menus li a{
	display: block;
	width: 100%;
}
.head-menu-mobile{
	display: none;
}
.mobile-menu{
	display: none;
}
.head-logo{
		height: 60px;
	}
	.head-logo {		
		width: 36%;
		height: 60px;
	}
	.head-logo>img{
		max-width: 100%;
	}
@media screen and ( max-width: 768px){
	.head-menu-mobile{
		display: block;
	}
	.iconfont{
		font-size: 36px;
	}
	.warp {
		width: 100% !important;
		min-width: 100%;
	}
	.head-menu{
		display: none;
	}
	.head-menu-mobile{		
		float: right;
		margin-top: 20px;
		margin-right: 5%;
	}
	.head-uppr{	
		height: 60px;		
	}
	.head-logo{
		height: 60px;
	}
	.head-logo {		
		width: 70%;
	}
	.head-logo img{
		height: 50%;
		width: 80%;
		margin-top: 15px;
	}
	.mobile-menu{
		display: block;
	}
	.mobile-menu .nav-menus a{
		display: block;
		width: 100%;
	}
	.mobile-menu .nav-menus{
		margin-left: 5%;
	}
	.mobile-menu .nav-menus li{
		border-top: 1px solid rgba(0,0,0,0.5);
	}
	.mobile-menu .alone-a{
		display: block;
		width: 100%;
	}
	.mobiedisplay{
		padding-bottom: 150%;
		/* height: 600px; */
		background: #fff;
		margin-top: 60px;
		border-top: 2px solid #932120;
	}
	.youClass{
		width: 100%;
		height: 100%;
		display: none;
	}
	.m-ul>li{
		width: 90%;
		text-align: left;
		margin-left: 5%;
		font-size: 16px;
		line-height: 40px;
		border-bottom: 1px solid rgba(147,33,32,0.5);
	}
	.m-ul span{
		margin-left: 72%;
	}
	.nav-children{
		display: none;
	}
	.nav-jian{

	}		
}
@media screen and ( max-width: 320px) {			
}
</style>